import Link from 'components/Basic/Link/Link';
import useTranslation from 'next-translate/useTranslation';
import { ProductDetailType, VariantDetailType } from 'types/product';

type ProductDetailBuyInEshopProps = {
    product: ProductDetailType | VariantDetailType;
};

const externalTescomaBaseLink = 'https://www.tescomaonline.com/product/';

const ProductDetailBuyInEshop: FC<ProductDetailBuyInEshopProps> = ({ product }) => {
    const { t } = useTranslation();

    const productExternalLink = externalTescomaBaseLink + product.catalogNumber.split('.')[0];

    if (product.isSaleExclusion) {
        return <div className="font-bold text-red">{t('This product is no longer sold')}</div>;
    }

    return (
        <Link isButton href={productExternalLink} target="_blank" variant="primary">
            {t('Buy in e-shop')}
        </Link>
    );
};

export default ProductDetailBuyInEshop;
